'use strict';

var makeStyles$1 = require('../../../../_virtual/makeStyles.js_commonjs-exports.js');
var interopRequireDefault = require('../../../@babel/runtime/helpers/interopRequireDefault.js');
var _extends = require('../../../@babel/runtime/helpers/extends.js');
var index = require('../../../../_virtual/index.js_commonjs-proxy.js');
require('./defaultTheme.js');
var defaultTheme = require('../../../../_virtual/defaultTheme.js_commonjs-exports.js');

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(makeStyles$1.__exports, "__esModule", {
  value: true
});
exports["default"] = makeStyles$1.__exports.default = void 0;

var _extends2 = _interopRequireDefault(_extends._extends_1);

var _styles = index;

var _defaultTheme = _interopRequireDefault(defaultTheme.__exports);

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _styles.makeStyles)(stylesOrCreator, (0, _extends2.default)({
    defaultTheme: _defaultTheme.default
  }, options));
}

var _default = makeStyles;
exports["default"] = makeStyles$1.__exports.default = _default;

module.exports = exports["default"];
